module.exports = __webpack_public_path__ + "img/slika46.7021f3b9.jpg";